import { OrderStatus } from "../../../api/endpoints/Order";
import React from "react";
import classNames from "classnames";

const OrderStatusBadge = (props: { status: OrderStatus }) => {
  const { status } = props;

  return <span className={classNames('order-status-badge', status)}>{status}</span>
}

export default OrderStatusBadge;
